module.exports = __webpack_public_path__ + "img/IMG_20181212_103617.1b0169b6.jpg";